import DataDisplayRowI from "../DataDisplayRowI";
import getMerchandiseRow from "../DataDisplayRow/MerchandiseRow";
import DataDisplayTable from "../DataDisplayTable";

class MerchandiseTable extends DataDisplayTable {
    #row!: DataDisplayRowI;

    generateRow(): DataDisplayRowI {
        return this.#row = getMerchandiseRow()
    }
}

let merchandiseTable: MerchandiseTable | null = null;

export default function getMerchandiseTable(): MerchandiseTable {
    if (merchandiseTable === null)
        merchandiseTable = new MerchandiseTable()
    return merchandiseTable
}